import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

export const useMarkAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const response = await apiClient.get(`/notifications/mark-as-read/${id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: ['unread-count'] });
    },
  });
};

export const useMarkSelectedAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (notificationIds) => {
      const formData = new FormData();
      notificationIds.forEach(id => formData.append('notification_ids[]', id));
      const response = await apiClient.post('/notifications/mark-selected-as-read', formData);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: ['unread-count'] });
    },
  });
};